export const KeyboardKeys = {
    BACKSPACE: { keyCode: 8, key: ' ' },
    TAB: { keyCode: 9, key: 'Tab' },
    ENTER: { keyCode: 13, key: 'Enter' },
    CONTROL: { keyCode: 17, key: 'Control' },
    SHIFT: { key: 'shift' },
    ESC: { keyCode: 27, key: 'Escape' },
    DELETE: { keyCode: 46, key: 'Delete' },
    f: { keyCode: 70, key: 'f' },
    g: { keyCode: 71, key: 'g' },
    G: { keyCode: 71, key: 'G' },
    F3: { keyCode: 114, key: 'F3' },
    UP: { keyCode: 38, key: 'ArrowUp' },
    DOWN: { keyCode: 40, key: 'ArrowDown' }
} as const;
